import { Component, OnInit, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { InterfaceElement } from 'src/app/model/asd/asd-properties/asd-ie/asd-interfaceElement';
import { FormMessage } from '../../model/form/form-properties/form-message';
import { UXControllerService } from 'src/app/service/controller/ux-controller.service';

@Component({
  selector: 'app-cosy-validatormessage',
  templateUrl: './cosy-validatormessage.component.html',
  styleUrls: ['./cosy-validatormessage.component.css']
})
export class CosyValidatormessageComponent implements OnInit {
  @Input() ie:InterfaceElement;
  @Input() formgroup:FormGroup;
  private FORM_MESSAGE = FormMessage;

  constructor(private uxControllerService: UXControllerService) { }

  ngOnInit() {
  }

}
